export default __webpack_public_path__ + "static/media/dashboard_delete.20ed22bf.svg";